import React, { useContext, useState } from "react";

import { assertNativeError } from "@examspark/common/dist/utils";
import { Modal, ModalProps, SubmitButtons, toast } from "@examspark/common-ui";

import { LTIContext } from "../../../providers/LTIProvider";

import NewClassroomForm, { NewClassroomFormData } from "./NewClassroomForm";
import { useMutationCreateClassroomAndUser } from "./NewClassroomManual";

const NewClassroomLTI = (
  props: Omit<ModalProps, "isOpen"> & {
    onCreate: () => void;
    onBack: () => void;
    hideCourseInput?: boolean;
    hideSubjectInput?: boolean;
    hideGradeInput?: boolean;
  },
) => {
  const lti = useContext(LTIContext);
  const createClassroom = useMutationCreateClassroomAndUser();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState<NewClassroomFormData>({
    name: lti?.token.data?.context_title ?? "",
    room: "",
    sectionNumber: "",
  });

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await createClassroom.mutateAsync({
        form,
        hideCourseInput: props.hideCourseInput,
        hideGradeInput: props.hideGradeInput,
        hideSubjectInput: props.hideSubjectInput,
      });
      toast.success("Classroom created");
      props.onCreate();
    } catch (error) {
      assertNativeError(error);
      alert(error.message);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal.Body>
        <div style={{ padding: "1rem" }}>
          <NewClassroomForm
            value={form}
            onChange={(value) => setForm(value)}
            hideCourseInput={props.hideCourseInput}
            hideGradeInput={props.hideGradeInput}
            hideSubjectInput={props.hideSubjectInput}
          />
        </div>
      </Modal.Body>
      <Modal.BasicFooter>
        <SubmitButtons
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          cancelLabel="Back"
          submitLabel="Create Classroom"
          onCancel={props.onBack}
        />
      </Modal.BasicFooter>
    </>
  );
};

export default NewClassroomLTI;
